(() => {
  // --- Kertainitointi ---
  if (window.__HANDLING_FEE_INIT__) return;
  window.__HANDLING_FEE_INIT__ = true;

  // --- Asetukset ---
  const ENABLED = true;
  const HANDLE = "pienkasittelykulu";
  const THRESHOLD_CENTS = 2250;         // 22.50 €
  const ENSURE_MIN_INTERVAL = 200;      // throttle ms
  const OBSERVER_DEBOUNCE = 160;        // DOM-observer debounce
  const CART_TTL = 240;                 // /cart.js TTL (ms)

  // /cart-sivun kova reload kun fee togglaa
  const FORCE_FULL_RELOAD_ON_CART_TOGGLE = true;
  const CART_HARD_RELOAD_THROTTLE_MS = 1500;

  // Sectionit joita päivitämme
  const SECTIONS = [
    "cart-drawer",
    "cart-icon-bubble",
    "main-cart-items",
    "main-cart-footer",
    "cart-live-region-text"
  ];

  // Juuri (tukee myös alikansioita, esim. /fi/)
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  if (!ENABLED || !HANDLE || Number.isNaN(THRESHOLD_CENTS)) return;

  // --- Sisäinen tila ---
  let _feeVariantId = 0;
  let _feeVariantPromise = null;
  let _updating = false;
  let _ensuring = false;
  let _ensureQueued = false;
  let _lastEnsureAt = 0;
  let _renderingByFee = false; // oma render-ajo käynnissä

  // Korivälimuisti
  let _cartPromise = null;
  let _cartTs = 0;

  // --- Apurit ---
  const debounce = (fn, ms = 120) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  };

  function invalidateCartCache() { _cartPromise = null; _cartTs = 0; }

  async function resolveFeeVariantId() {
    if (_feeVariantId) return _feeVariantId;
    if (!_feeVariantPromise) {
      _feeVariantPromise = (async () => {
        try {
          const res = await fetch(`/products/${HANDLE}.js`, { credentials: "same-origin" });
          if (!res.ok) return 0;
          const p = await res.json();
          const v = (p?.variants || []).find(v => v?.available) || (p?.variants || [])[0];
          return v?.id ? Number(v.id) : 0;
        } catch { return 0; }
      })();
    }
    _feeVariantId = await _feeVariantPromise;
    return _feeVariantId;
  }

  async function getCart({ force = false } = {}) {
    const now = performance.now();
    if (!force && _cartPromise && (now - _cartTs) < CART_TTL) return _cartPromise;
    _cartTs = now;
    _cartPromise = fetch("/cart.js", { credentials: "same-origin" })
      .then(r => r.ok ? r.json() : { items: [], items_subtotal_price: 0 })
      .catch(() => ({ items: [], items_subtotal_price: 0 }));
    return _cartPromise;
  }

  function feeLine(cart, feeVariantId) {
    return (cart.items || []).find(it => Number(it.variant_id) === feeVariantId) || null;
  }

  // Raja lasketaan rivisummista (final_line_price), fee-rivi pois
  function subtotalExcludingFeeCents(cart, feeVariantId) {
    let sum = 0;
    for (const it of (cart.items || [])) {
      if (Number(it.variant_id) === feeVariantId) continue;
      const line = typeof it.final_line_price === "number"
        ? it.final_line_price
        : (Number(it.price) || 0) * (Number(it.quantity) || 0);
      sum += (line | 0);
    }
    return sum;
  }

  // *** UUSI: muiden kuin fee-rivien määrä (qty-summa) ***
  function nonFeeItemQty(cart, feeVariantId) {
    let qty = 0;
    for (const it of (cart.items || [])) {
      if (Number(it.variant_id) === feeVariantId) continue;
      qty += Number(it.quantity) || 0;
    }
    return qty;
  }

  function updateInfoBanner(show) {
    const sels = [
      "#cart-drawer .cart__note-message",
      "#CartDrawer .cart__note-message",
      "#main-cart-items .cart__note-message",
      ".cart__note-message"
    ];
    for (const sel of sels) {
      document.querySelectorAll(sel).forEach(el => { el.style.display = show ? "" : "none"; });
    }
  }

  function hideFeeControlsInDOM(feeVariantId) {
    if (!feeVariantId) return;

    const rows = new Set();

    document
      .querySelectorAll(`input.quantity__input[data-quantity-variant-id="${feeVariantId}"]`)
      .forEach(inp => { const row = inp.closest(".cart-item"); if (row) rows.add(row); });

    if (rows.size === 0) {
      const linkSel = [
        `a.cart-item__name[href*="variant=${feeVariantId}"]`,
        `a.cart-item__name[href^="/products/${HANDLE}"]`
      ].join(",");
      document.querySelectorAll(linkSel).forEach(a => {
        const row = a.closest(".cart-item"); if (row) rows.add(row);
      });
    }

    rows.forEach(row => {
      const qtyWrap = row.querySelector(".cart-item__quantity-wrapper");
      if (qtyWrap) qtyWrap.style.display = "none";

      const removeBtn =
        row.querySelector(`button.cart-remove-button[data-variant-id="${feeVariantId}"]`) ||
        row.querySelector("cart-remove-button .cart-remove-button") ||
        row.querySelector(".cart-remove-button") ||
        row.querySelector("[data-cart-remove]") ||
        row.querySelector("[data-remove]") ||
        row.querySelector(".cart-item__remove") ||
        row.querySelector('button[name="remove"]') ||
        row.querySelector('a[href*="cart/change?"][data-quantity="0"]');

      if (removeBtn) {
        removeBtn.style.display = "none";
        removeBtn.style.pointerEvents = "none";
        removeBtn.setAttribute("aria-hidden", "true");
        removeBtn.setAttribute("tabindex", "-1");
      }
    });
  }

  // --- /cart-sivun reload-helperit ---
  function isCartPage() {
    try {
      if (document.getElementById("main-cart-items")) return true;
      const p = location.pathname.replace(/\/+$/, "");
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      const rel = p.startsWith(root) ? p.slice(root.length - 1) : p;
      return /\/cart$/.test(rel);
    } catch { return false; }
  }

  function scheduleCartHardReload() {
    try {
      const k = "__FEE_RLD_AT__";
      const now = Date.now();
      const last = Number(sessionStorage.getItem(k)) || 0;
      if (now - last < CART_HARD_RELOAD_THROTTLE_MS) return;
      sessionStorage.setItem(k, String(now));
    } catch {}
    setTimeout(() => { location.reload(); }, 80);
  }

  function maybeReloadCartPageOnToggle() {
    if (!FORCE_FULL_RELOAD_ON_CART_TOGGLE) return;
    if (isCartPage()) scheduleCartHardReload();
  }

  // --- ENSISIJAINEN renderöinti teeman metodeilla ---
  async function renderSectionsPreferred(htmlById) {
    const drawerEl = document.querySelector("cart-drawer");
    const cartItemsEl = document.querySelector("cart-items");

    // Cart page
    if (cartItemsEl && typeof cartItemsEl.renderContents === "function") {
      _renderingByFee = true;
      try {
        const parsedForCart = {
          id: _feeVariantId || 0,
          sections: {
            "main-cart-items": htmlById["main-cart-items"] || "",
            "main-cart-footer": htmlById["main-cart-footer"] || "",
            "cart-icon-bubble": htmlById["cart-icon-bubble"] || ""
          }
        };
        cartItemsEl.renderContents(parsedForCart);
      } finally {
        _renderingByFee = false;
      }
    }

    // Drawer
    if (drawerEl && typeof drawerEl.renderContents === "function") {
      _renderingByFee = true;
      try {
        const parsedForDrawer = {
          id: _feeVariantId || 0,
          sections: {
            "cart-drawer": htmlById["cart-drawer"] || "",
            "cart-icon-bubble": htmlById["cart-icon-bubble"] || ""
          }
        };
        drawerEl.renderContents(parsedForDrawer);
      } finally {
        _renderingByFee = false;
      }
    }

    // Fallback
    if ((!cartItemsEl || typeof cartItemsEl.renderContents !== "function") &&
        (!drawerEl    || typeof drawerEl.renderContents    !== "function")) {
      for (const id of SECTIONS) {
        const wrapper = document.querySelector(`#shopify-section-${id}`);
        if (wrapper && htmlById[id]) {
          const tmp = document.createElement("div");
          tmp.innerHTML = htmlById[id];
          wrapper.outerHTML = tmp.firstElementChild?.outerHTML || htmlById[id];
        }
      }
    }

    if (_feeVariantId) requestAnimationFrame(() => hideFeeControlsInDOM(_feeVariantId));
  }

  async function refreshCartUI({ openDrawerOnAdd = false, showInfoBanner = null } = {}) {
    const url = `${ROOT}?sections=${SECTIONS.join(",")}&_fee=1&_=${Date.now()}`;
    try {
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) return;
      const htmlById = await res.json();

      await renderSectionsPreferred(htmlById);

      if (openDrawerOnAdd) {
        document.querySelector("cart-drawer")?.open?.();
      }

      attachObservers(); // uudet nodet -> observerit uusiksi
      if (showInfoBanner !== null) updateInfoBanner(showInfoBanner);
    } catch { /* no-op */ }
  }

  async function addOrClampFee(feeVariantId) {
    _updating = true;
    try {
      const cart = await getCart({ force: true });
      const fee = feeLine(cart, feeVariantId);
      if (fee && fee.quantity !== 1) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ updates: { [feeVariantId]: 1 } })
        });
        invalidateCartCache();
      } else if (!fee) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ id: feeVariantId, quantity: 1, properties: { _auto_fee: "true" } })
        });
        invalidateCartCache();
      }
    } finally {
      _updating = false;
    }
  }

  async function removeFee(feeVariantId) {
    _updating = true;
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ updates: { [feeVariantId]: 0 } })
      });
      invalidateCartCache();
    } finally {
      _updating = false;
    }
  }

  // --- Throttle ---
  function queueEnsure(_reason = "") {
    const now = Date.now();
    if (_ensureQueued) return;
    const wait = Math.max(0, ENSURE_MIN_INTERVAL - (now - _lastEnsureAt));
    _ensureQueued = true;
    setTimeout(async () => {
      _ensureQueued = false;
      _lastEnsureAt = Date.now();
      await ensureFee();
    }, wait);
  }

  async function ensureFee() {
    if (_updating || _ensuring) return;
    _ensuring = true;
    try {
      const feeVariantId = await resolveFeeVariantId();
      if (!feeVariantId) return;

      const cart = await getCart({ force: true });

      // *** UUSI: lisää fee vain jos korissa on vähintään yksi "muu" rivi ***
      const nonFeeQty = nonFeeItemQty(cart, feeVariantId);
      const subtotalNoFee = subtotalExcludingFeeCents(cart, feeVariantId);
      const shouldHaveFee = (nonFeeQty > 0) && (subtotalNoFee < THRESHOLD_CENTS);

      const fee = feeLine(cart, feeVariantId);

      if (shouldHaveFee && !fee) {
        await addOrClampFee(feeVariantId);
        await refreshCartUI({ openDrawerOnAdd: true, showInfoBanner: true });
        maybeReloadCartPageOnToggle();
      } else if (shouldHaveFee && fee?.quantity !== 1) {
        await addOrClampFee(feeVariantId);
        await refreshCartUI({ openDrawerOnAdd: false, showInfoBanner: true });
      } else if (!shouldHaveFee && fee) {
        await removeFee(feeVariantId);
        await refreshCartUI({ openDrawerOnAdd: false, showInfoBanner: false });
        maybeReloadCartPageOnToggle();
      } else {
        hideFeeControlsInDOM(feeVariantId);
        // Info näkyviin vain jos on muitakin rivejä JA alitetaan raja
        updateInfoBanner((nonFeeQty > 0) && (subtotalNoFee < THRESHOLD_CENTS));
      }
    } finally {
      _ensuring = false;
    }
  }

  // --- Checkout-varmistus ---
  document.addEventListener("click", async (e) => {
    const el = e.target.closest("a,button");
    if (!el) return;
    const href = el.getAttribute("href") || "";
    const isCheckout = /\/checkout(\?|$)/.test(href) || el.name === "checkout";
    if (!isCheckout) return;

    const feeVariantId = await resolveFeeVariantId();
    if (!feeVariantId) return;

    const cart = await getCart({ force: true });
    const nonFeeQty = nonFeeItemQty(cart, feeVariantId);
    const shouldHaveFee = (nonFeeQty > 0) && (subtotalExcludingFeeCents(cart, feeVariantId) < THRESHOLD_CENTS);
    const fee = feeLine(cart, feeVariantId);

    if ((shouldHaveFee && !fee) || (!shouldHaveFee && fee) || (fee && fee.quantity !== 1)) {
      e.preventDefault();
      await ensureFee();
      if (href) location.href = href; else location.assign("/checkout");
    }
  }, { capture: true });

  // --- Triggers ---
  document.addEventListener("DOMContentLoaded", () => queueEnsure("dom-ready"));
  document.addEventListener("visibilitychange", () => { if (!document.hidden) queueEnsure("visible"); });

  // Kuuntele määräkenttiä (varmuus jos jokin appi ei käytä cart API:a)
  document.addEventListener("change", (e) => {
    const t = e.target;
    if (!t) return;
    if (t.matches('input[name="updates[]"], .quantity__input, [data-quantity-input]')) {
      queueEnsure("qty-change");
    }
  });

  // FETCH-patch: cart API:t + teeman sections-päivitykset
  if (!window.__HANDLING_FEE_FETCH_PATCHED__) {
    const _origFetch = window.fetch;
    window.__HANDLING_FEE_FETCH_PATCHED__ = true;
    window.fetch = function(resource, init) {
      const resP = _origFetch.apply(this, arguments);
      try {
        const url = typeof resource === "string" ? resource : resource?.url || "";

        if (/\/cart\/(add|update|change|clear)\.js(\?|$)/.test(url)) {
          invalidateCartCache();
          resP.finally(() => queueEnsure("cart-api"));
        }
        else if (/\?sections=/.test(url) &&
                 !/[?&]_fee=1/.test(url) &&
                 /(cart-drawer|cart-icon-bubble|main-cart-items|main-cart-footer|cart-live-region-text)/.test(url)) {
          resP.finally(() => queueEnsure("theme-sections"));
        }
      } catch { /* no-op */ }
      return resP;
    };
  }

  // Patchaa customShopify.updateCart (drawer) jos löytyy
  if (window.customShopify && typeof window.customShopify.updateCart === "function" && !window.__HANDLING_FEE_PATCHED_UPDATECART__) {
    const orig = window.customShopify.updateCart.bind(window.customShopify);
    window.__HANDLING_FEE_PATCHED_UPDATECART__ = true;
    window.customShopify.updateCart = function() {
      const r = orig.apply(this, arguments);
      if (!_renderingByFee) queueEnsure("customShopify.updateCart");
      return r;
    };
  }

  // --- Observerit ---
  const debouncedEnsure = debounce(() => { queueEnsure("dom-change"); }, OBSERVER_DEBOUNCE);

  function attachObservers() {
    const targets = [
      document.getElementById("cart-drawer") || document.querySelector("#shopify-section-cart-drawer"),
      document.getElementById("CartDrawer-CartItems"),
      document.getElementById("main-cart-items"),
      document.getElementById("main-cart-footer")
    ].filter(Boolean);

    if (window.__HANDLING_FEE_MOS__) window.__HANDLING_FEE_MOS__.forEach(mo => mo.disconnect());
    window.__HANDLING_FEE_MOS__ = [];

    targets.forEach(t => {
      const mo = new MutationObserver(() => {
        debouncedEnsure();
        if (_feeVariantId) hideFeeControlsInDOM(_feeVariantId);
      });
      mo.observe(t, { childList: true, subtree: true });
      window.__HANDLING_FEE_MOS__.push(mo);
    });
  }

  attachObservers();
})();
